import React from "react";
import { useNavigate } from "react-router-dom";
import { useOpenState } from "../contexts/OpenContext";

const AdminSidebar = () => {
  const navigate = useNavigate();
  const { state, Logout } = useOpenState();
  return (
    <div className="hidden md:block h-screen w-[300px] p-4 border-r bg-gray-50 select-none">
      <div
        className="flex items-center border-b pb-4 cursor-pointer"
        onClick={() => navigate("/")}
      >
        <img src="/img/logo.png" alt="" className="h-10" />
      </div>
      <div className="flex flex-col items-center justify-center mt-4">
        <img
          src={"https://ef.erdenetmc.mn/emp/" + state?.tn + ".jpg"}
          alt=""
          className="w-[60px] h-[60px] object-fill rounded-full"
        />
        <div className="text-[#031b4e] font-semibold text-lg mt-2">
          {state?.info?.shortname}
        </div>
        <div className="whitespace-pre-wrap text-[#97a3b9] px-7 text-center text-sm">
          {state?.info?.position_namemn}
        </div>
        <div
          className="w-10 h-10 bg-slate-200 flex items-center justify-center rounded-full border mt-2 cursor-pointer"
          onClick={() => Logout()}
        >
          <i className="fa fa-power-off" />
        </div>
      </div>
      {/* <div className="flex justify-center flex-col px-4">
        <div
          className={
            pathname === "/admin/category"
              ? "border-b-2 border-green-600 py-2 cursor-pointer my-2"
              : "border-b py-2 cursor-pointer my-2"
          }
          onClick={() => navigate("/admin/category")}
        >
          Бүлэг
        </div>
        <div
          className={
            pathname === "/admin/article"
              ? "border-b-2 border-green-600 py-2 cursor-pointer my-2"
              : "border-b py-2 cursor-pointer my-2"
          }
          onClick={() => navigate("/admin/article")}
        >
          Дэд бүлэг
        </div>
        <div
          className={
            pathname === "/admin/data"
              ? "border-b-2 border-green-600 py-2 cursor-pointer my-2"
              : "border-b py-2 cursor-pointer my-2"
          }
          onClick={() => navigate("/admin/data")}
        >
          Нийлэл
        </div>
      </div> */}
    </div>
  );
};

export default React.memo(AdminSidebar);
